<script>
  import axios from 'axios'
  import md5 from 'md5'
  import Token from './Token'

  export default {
    data () {
      return {
        tmp: {},
      }
    },

    methods: {
      async get (uri, params = {}, use_token = true, cache = false) {
        if (cache) {
          const cached_data = this.tmp[md5(uri + params.toString())]

          if (cached_data && cached_data.expire && moment().isBefore(cached_data.expire)) {
            return Promise.resolve(cached_data)
          }
        }

        let headers = {
          'Accept': 'application/json',
        }

        if (use_token) {
          headers['Authorization'] = 'Bearer ' + this.getToken().access_token
        }

        return axios.get(uri, { params: params, headers: headers })
          .then(response => {
            if (cache) {
              response.expire = moment().add(15, 'm')
              this.tmp[md5(uri + params.toString())] = response;
            }

            return Promise.resolve(response);
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.logout()
            }

            return Promise.reject(error);
          })
      },

      async post (uri, body = null, use_token = true) {
        let headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }

        if (use_token) {
          headers['Authorization'] = 'Bearer ' + this.getToken().access_token
        }

        return axios.post(uri, body, { headers: headers })
          .catch(error => {
            if (error.response.status === 401) {
              this.logout()
            }

            return Promise.reject(error);
          })
      },

      async put (uri, body = null, use_token = true) {
        let headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }

        if (use_token) {
          headers['Authorization'] = 'Bearer ' + this.getToken().access_token
        }

        return axios.put(uri, body, { headers: headers })
          .catch(error => {
            if (error.response.status === 401) {
              this.logout()
            }

            return Promise.reject(error);
          })
      },

      logOut () {
        this.clearToken()

        this.$router.push('/login')
      },
    },

    mixins: [
      Token,
    ],
  }
</script>
